import { render, staticRenderFns } from "./UpdateNotification.vue?vue&type=template&id=29934b84&scoped=true&"
import script from "./UpdateNotification.vue?vue&type=script&lang=ts&"
export * from "./UpdateNotification.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateNotification.vue?vue&type=style&index=0&id=29934b84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29934b84",
  null
  
)

export default component.exports